// extracted by mini-css-extract-plugin
module.exports = {"showResult":"ResultAnalysis_showResult__3Wpm-","message":"ResultAnalysis_message__2t5TB","icon":"ResultAnalysis_icon__2Rnxz","centerButton":"ResultAnalysis_centerButton__3uO1c"};